import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";

export class IncidentAccidentModel {
    public Id: number;
    public Date: NgbDateStruct;
    public Time: NgbTimeStruct;
    public SiteId: number;
    public AccountId: number;
    public SiteName: string;
    public Location: string;

    public Affected: string;
    public Event: string;
    public ProbableCause: string;
    public Damages: string;
    public Reporter: string;
    public Skadetyp: number;
    public EstimatedCost: number;

    public AccidentType: number;
    public Status: number;
    public InternalCaseNumber: string;
    public ExternalCaseNumber: string;
    public Comments: IncidentAccidentCommentModel[] = [];

    public Email: string;
    public Phone: string;
    public Name: string;
    public SendToEmail: boolean = true;
    public DefaultEmail: string;
    public Cost: number;

    public ChangedBy: string;
    public ChangedTime: Date;
}

export class SkadetypModel {
    public Id: number;
    public Name: string;
    public Type: number;
    public AccountId: number;
}

export class IncidentAccidentCommentModel {
    public Id: number;
    public IncidentAccidentId: number;
    public Date: Date;
    public Comment: string;
    public Requirements: number;
    public Disbursed: number;
    public CompensationFromInsurance: number;
    public CompensationFromOthers: number;
    public DateModel: NgbDateStruct;
    public TimeModel: NgbTimeStruct;
    public Name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/incidentAccidentModel.ts